import { setFoulsOnPeriod } from 'modules/overlay-v2/store/game-info/game-info';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store/store';
import { DivProps } from 'typings';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Counter from './counter';

interface IProps extends DivProps {
  teamIndex: number;
  period: number;
}

function Fouls(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { teamIndex, period, ...rest } = props;

  const { fouls } = useGameInfo();
  const { send } = usePopupMessenger();
  const prefix = teamIndex === 0 ? 'first' : 'second';

  const teamScore = useMemo(() => {
    return fouls?.[prefix] ?? 0;
  }, [fouls, prefix]);

  const handleChangeFouls = useCallback(
    (newValue: number) => {
      dispatch(setFoulsOnPeriod({ [prefix]: newValue, period }));
      send({ type: 'setFouls', [prefix]: newValue, period });
    },
    [dispatch, send, period, prefix],
  );

  return <Counter setValue={handleChangeFouls} value={teamScore} title={'Фолы'} titleWidth={40} {...rest} />;
}

export default Fouls;
